export const aiPackage = {
  hotel: {
    name: "三亚亚龙湾瑞吉度假酒店",
    rating: 4.8,
    address: "三亚市亚龙湾国家旅游度假区",
    checkIn: "2025-05-01",
    checkOut: "2025-05-05",
    price: 3200,
    image: "https://readdy.ai/api/search-image?query=luxury%20five%20star%20resort%20hotel%20in%20Sanya%20Yalong%20Bay%20with%20pool%2C%20tropical%20palm%20trees%2C%20ocean%20view%2C%20modern%20architecture%2C%20warm%20lighting%2C%20professional%20hotel%20photography&width=80&height=80&seq=301&orientation=squarish",
  },
  car: {
    model: "别克 GL8 商务7座",
    pickupLocation: "三亚凤凰国际机场",
    returnLocation: "三亚凤凰国际机场",
    pickupTime: "2025-05-01 14:00",
    returnTime: "2025-05-05 12:00",
    price: 900,
    image: "https://readdy.ai/api/search-image?query=Buick%20GL8%20modern%20MPV%20business%20car%20white%20color%2C%20clean%20simple%20background%2C%20professional%20automotive%20photography&width=80&height=80&seq=302&orientation=squarish",
  },
  tour: {
    name: "三亚5日经典游",
    summary: "蜈支洲岛 · 天涯海角 · 南山文化苑 · 亚特兰蒂斯",
    dates: "2025-05-01 ~ 2025-05-05",
    price: 2400,
    image: "https://readdy.ai/api/search-image?query=Sanya%20Wuzhizhou%20island%20crystal%20clear%20blue%20water%20coral%20reef%20snorkeling%20spot%2C%20tropical%20paradise%2C%20bright%20sunny%20day%2C%20travel%20destination%20photography&width=80&height=80&seq=303&orientation=squarish",
  },
  guide: {
    name: "陈美玲",
    language: "普通话 / 英语",
    rating: 5.0,
    dates: "2025-05-01 ~ 2025-05-03（2天）",
    price: 1500,
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20tour%20guide%20portrait%20smiling%20confidently%2C%20wearing%20uniform%2C%20tropical%20background%2C%20headshot%20photography&width=80&height=80&seq=304&orientation=squarish",
  },
};

export const voiceHints = [
  "试试说：三亚5天4晚4人",
  "亲子酒店预算800/晚",
  "租车GL8带司机",
  "大理3日游2人",
  "5月1日出发，4人，含导游",
];
